module.exports = __webpack_public_path__ + "59c24b920a5955e7a7d5073f430f2b85.png";